import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { TestAnswersDto } from '@model/ClientTestAnswerDto'
import { ClientTestDto } from '@model/ClientTestDto'
import { TickmillProductType } from '@model/TickmillProductType'

export interface AccountAppTestResponseProps {
  accountAppTest: ClientTestDto | undefined
  accountAppTestAnswers: TestAnswersDto | undefined
  isLoading: boolean
}

export const useAccountAppTestFetch = (
  productId: TickmillProductType
): AccountAppTestResponseProps => {
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.accountAppTest(locale, productId),
    queryFn: async () => {
      const accountAppTestResult = await apiClient.getClientAppTests(locale, productId)
      try {
        const accountAppTestAnswersResult: TestAnswersDto =
          await apiClient.getAccountAppTestAnswers(locale, productId)
        return {
          accountAppTest: accountAppTestResult
            ? {
                ...accountAppTestResult,
                sections: accountAppTestResult.sections.sort((a, b) => a.order - b.order),
              }
            : undefined,
          accountAppTestAnswers: accountAppTestAnswersResult,
        }
      } catch (error: unknown) {
        console.error(error)
        return {
          accountAppTest: accountAppTestResult
            ? {
                ...accountAppTestResult,
                sections: accountAppTestResult.sections.sort((a, b) => a.order - b.order),
              }
            : undefined,
          accountAppTestAnswers: undefined,
        }
      }
    },
    enabled: !!locale,
  })

  const { accountAppTest, accountAppTestAnswers } = data || {}
  return { accountAppTest, accountAppTestAnswers, isLoading }
}
